import './demo-component';


// WEBPACK FOOTER //
// src/index.js